export default "__VITE_ASSET__DhZqRARk__"